import { useStyletron } from '@thanx/uikit/theme'
import { Order } from 'api/orders'
import HeaderCell from 'components/HeaderCell'
import { buildTranslate } from 'locales'
import React from 'react'
import { useAbility } from 'utilities/ability'
import OloRow from './OloRow'
import Row from './Row'

const t = buildTranslate('users.view.activity.orders')

type PropsT = {
  orders: Array<Order>
  onDetailsClick?: (order: Order) => void
}

const Table: React.FC<PropsT> = ({ orders, onDetailsClick }: PropsT) => {
  const [css] = useStyletron()
  const hasOloOrders = orders.some(order => order.ordering_provider === 'olo')
  // AI-1291 (FR-61): customer-membership view ('Users') already gates the
  // whole Activity tab one level up — this is the narrower ratings-and-reviews
  // gate, same CASL subject/action used at
  // scenes/Reports/OrderFeedbackReport/index.tsx:107 and the Order feedback
  // tab (../OrderFeedback/index.tsx). The Orders tab keeps listing orders;
  // only the Rating column drops, mirroring the server's own "degrade, don't
  // gate" treatment of the orders endpoint's rating lookup (N4).
  const canViewFeedback = useAbility().can('access', 'Feedback')

  return (
    <table
      className={`full-width ${css({
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
      })}`}
    >
      <thead>
        <tr>
          {hasOloOrders && <HeaderCell>{t('provider_basket_uid')}</HeaderCell>}
          <HeaderCell>{t('provider_order_uid')}</HeaderCell>
          <HeaderCell>{t('handoff')}</HeaderCell>
          <HeaderCell>{t('status')}</HeaderCell>
          <HeaderCell>{t('total')}</HeaderCell>
          <HeaderCell>{t('placed_at')}</HeaderCell>
          {canViewFeedback && <HeaderCell>{t('rating')}</HeaderCell>}
          <HeaderCell></HeaderCell>
        </tr>
      </thead>
      <tbody>
        {orders.map(order => (
          <React.Fragment key={order.id}>
            {order.ordering_provider !== 'olo' ? (
              <Row
                key={`orders_${order.id}`}
                order={order}
                onDetailsClick={onDetailsClick}
                showRating={canViewFeedback}
              />
            ) : (
              <OloRow
                key={`orders_${order.id}`}
                order={order}
                onDetailsClick={onDetailsClick}
                showRating={canViewFeedback}
              />
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  )
}

export default Table
